import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { ApprovalWorkflowItemDto } from '@api/Api';
import Status from '@components/Approval/Status';

type ProgressCellProps = {
  approvalWorkflow: ApprovalWorkflowItemDto;
};

export default memo(function ProgressCell({
  approvalWorkflow
}: ProgressCellProps) {
  const activeStage = useMemo(() => {
    if (!approvalWorkflow?.stages?.length) return null;
    if (!approvalWorkflow?.currentStageId) return approvalWorkflow.stages[0];
    return approvalWorkflow?.stages.find(
      (item) => item.id === approvalWorkflow.currentStageId
    );
  }, [approvalWorkflow?.stages, approvalWorkflow.currentStageId]);

  return (
    <div className={classNames('progress-cell')}>
      <Status
        status={approvalWorkflow.status}
        isPaused={approvalWorkflow.isPaused}
        deadline={activeStage?.deadline}
        showStatusDot={approvalWorkflow.isPaused}
      />
    </div>
  );
});
